import React, { useContext, useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import ResponsiveDataTable from "../../../../components/DataTable";
import LoadingSpinner from "../../../../components/LoadinSpinner";
import { ConsultaTotvsEmpresa } from "../../../../../backend/ConsultaTotvsEmpresa";
import { useNavigate, useParams } from "react-router-dom";
import { usePopUp } from "../../../../components/BootBox";
import ConsumoTOTVS_POST from "../../../../../backend/ConsumoTotvs";
import { ErroMsg, SucessoMsg } from "../../../../contents/VariaveisGlobais";
import SubmitForm from "../../../../components/SubmitForm";

function ListaContatos(){
    const navigate = useNavigate();
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    const [carregar, setCarregar] = useState(false);
    const [data, setData]   = useState([]);
    const { Fornecedor, Loja, empresaFilial } = useParams();    

    const consultaDefault = "SELECT U5_CODCONT, U5_CONTAT, U5_FONE, U5_EMAIL, U5_CELULAR FROM TABELA(SU5) SU5 " +
        "LEFT JOIN TABELA(AC8) AC8 ON AC8_FILIAL = U5_FILIAL AND AC8_ENTIDA = 'SA2' AND AC8_CODCON = U5_CODCONT AND AC8_STATUS <> 'I' AND AC8.D_E_L_E_T_ <> '*' " +
        "WHERE SU5.D_E_L_E_T_ <> '*' AND AC8_CODENT = '" + Fornecedor + Loja + "' " +
        "AND UPPER(U5_CONTAT) <> 'NOVO CONTATO' " +
        "ORDER BY U5_CODCONT ";
    
    const columns = [
        {
            Header: 'Contatos',
            accessor: 'U5_CODCONT',
        },
        {
            Header: 'Nome',
            accessor: 'U5_CONTAT',
        },
        {
            Header: 'TELEFONE',
            accessor: 'U5_FONE',
        },
        {
            Header: 'CELULAR',
            accessor: 'U5_CELULAR',
        },
        {
            Header: 'E-mail',
            accessor: 'U5_EMAIL',
        }        
    ];
        

    useEffect(() => {
        loadContatos();
    }, []);

    // Processa consulta do grid
    const loadContatos = async () => {
        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, "SU5;AC8", empresaFilial )
        setData(retConsulta.data);
        setCarregar(false);
    }

    const handleExcluir = async (row) => {
        const idRow = row.original.U5_CODCONT;
        const Mensagem = `Tem certeza que deseja excluir o Contato ${row.original.U5_CONTAT}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(row) => {        
        const cJSONSalvar = { 
            ACAO: "EXCLUIR", 
            CONTATOSU5: row,
            FORNECEDOR: Fornecedor,
            LOJA: Loja,
        }

        FechaBootBox()
        try {
            setCarregar(true);

            const oRetorno = await ConsumoTOTVS_POST('CONTATOFORNECEDOR', cJSONSalvar, empresaFilial)
            
            if (oRetorno.error === '00'){
                SucessoMsg(oRetorno.description)
            }else{
                ErroMsg(oRetorno.description)
                return false;
            }
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
            loadContatos();
        }
    };

    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage 
                    text="Contatos"
                />
            </Col>
            <Col md="3" xs="12">
                <Form.Group as={Col} className="md-2" controlId="formGridBuscar">
                    <InputGroup size="md" className="mb-3">
                        <Button variant="outline-primary" type="submit" onClick={loadContatos}>
                            Buscar
                        </Button>
                    </InputGroup>
                </Form.Group>
            </Col>
        </Row>
        
        <Row>
            { data.length > 0 &&
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons= {[
                            { isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger" }
                        ]}
                        isIgnorar={true}
                    />
                </Col>
            }
        </Row>

        <SubmitForm
            onVoltar={"Voltar"}
        />
        </>
    );
}

export default ListaContatos;